// client\src\services\lessonService.js
import apiClient from '../utils/apiClient';

export const getLesson = async (lessonId) => {
    try {
        const response = await apiClient.get(`/lesson/${lessonId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching lesson:", error);
        return { success: false, message: "Failed to fetch lesson", data: null };
    }
};

export const markLessonComplete = async (lessonId) => {
    try {
        const response = await apiClient.post(`/lesson/${lessonId}/complete`);
        return response.data;
    } catch (error) {
        console.error("Error marking lesson as complete:", error);
        return { success: false, message: "Failed to mark lesson as complete" };
    }
};

export const submitQuiz = async (quizId, responses) => {
    try {
        const response = await apiClient.post('/quiz/submit', { quizId, responses });
        return response.data;
    } catch (error) {
        console.error("Error submitting quiz:", error);
        return { success: false, message: "Failed to submit quiz", data: null };
    }
};
